import { render } from "./add-product-modal.vue?vue&type=template&id=31802976"
import script from "./add-product-modal.vue?vue&type=script&lang=js"
export * from "./add-product-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__